import { uiSurface } from "shared/ui/uiSurface"
import { Box, Button, Stack } from "@mui/material"
import { FC } from "react"
import { useTranslation } from "react-i18next"

type Props = {
  onCreateAndNew: () => void
  onCreateAndClose: () => void
  onCancel: () => void
  isSubmitting: boolean
  isValid: boolean
}

export const OrderCreateDialogActions: FC<Props> = ({
  onCreateAndNew,
  onCreateAndClose,
  onCancel,
  isSubmitting,
  isValid,
}) => {
  const { t } = useTranslation()

  return (
    <Box
      {...uiSurface("UI-DLV2-041")}
      data-testid="order-create-actions"
      sx={{
        px: 3,
        py: 1.5,
        borderTop: 1,
        borderColor: "divider",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        bgcolor: "grey.50",
      }}
    >
      <Button
        data-testid="order-create-cancel-btn"
        onClick={onCancel}
        disabled={isSubmitting}
      >
        {t("cancel")}
      </Button>
      <Stack direction="row" spacing={1}>
        <Button
          data-testid="order-create-and-new-btn"
          variant="outlined"
          onClick={onCreateAndNew}
          disabled={isSubmitting || !isValid}
        >
          {t("orderCreate.createAndNew")}
        </Button>
        <Button
          data-testid="order-create-and-close-btn"
          variant="contained"
          onClick={onCreateAndClose}
          disabled={isSubmitting || !isValid}
        >
          {t("orderCreate.createAndClose")}
        </Button>
      </Stack>
    </Box>
  )
}
